import { Fetch } from '.';
import { View } from '../types/View';

export const exportData =
  (f: Fetch) =>
  async (refId: string, payload: View.SearchPayload, type: 'csv' = 'csv') =>
    f.fetchWithToken(`/export?type=${type}&refId=${refId}`, {
      method: 'POST',
      body: JSON.stringify(payload)
    });
